/** ******************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2016, 2025
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} * */

// Create a navigation function that can be easily mocked in tests
export const navigateTo = (url) => {
  window.location.assign(url);
};

/**
 * Validates if a URL is safe to use with window.location
 * Only allows https: protocol for security
 * @param urlString The URL string to validate
 * @returns true if the URL is valid and uses https protocol, false otherwise
 */
export const isUrlSafe = (urlString) => {
  if (!urlString || urlString.trim() === '') {
    return false;
  }

  try {
    const url = new URL(urlString);

    return url.protocol === 'https:';
  } catch {
    // If URL parsing fails (malformed URL), return false
    return false;
  }
};

/**
 * Safely navigates to a URL after validating it
 * Only allows https: protocol for security
 * @param urlString The URL string to navigate to
 * @returns true if navigation was attempted, false if URL was invalid/unsafe
 */
export const safeNavigate = (urlString) => {
  if (!isUrlSafe(urlString)) {
    return false;
  }

  try {
    const url = new URL(urlString);
    navigateTo(url.href);
    return true;
  } catch {
    console.warn('Error navigating to URL:', urlString);
    return false;
  }
};
